// GETTERS
export const GET_PATIENT = 'patient/GET_PATIENT';
export const GET_PATIENT_LIST = 'patient/GET_PATIENT_LIST';


// MUTATORS
export const MUTATE_LIST_PATIENT = 'patient/MUTATE_LIST_PATIENT';
export const MUTATE_PATIENT = 'patient/MUTATE_PATIENT';


// ACTIONS
export const ACTION_LIST_PATIENTS = 'patient/ACTION_LIST_PATIENTS';
export const ACTION_ADD = 'patient/ACTION_ADD';
export const ACTION_GET_PATIENT = 'patient/ACTION_GET_PATIENT';
export const ACTION_EDIT = 'patient/ACTION_EDIT';
export const ACTION_TREND = 'patient/ACTION_TREND';
export const ACTION_AGGREGATE = 'patient/ACTION_AGGREGATE';



// WEBPACK FOOTER //
// ./src/store/constants/patient.js